export const PENDING_SCHEDULING: string = 'Pending Scheduling';
export const RESCHEDULE_EVALUATION_MEETING: string =
  'Reschedule Evaluation Meeting';
export const SCHEDULED: string = 'Scheduled';
export const SCHEDULE_EVALUATION_MEETING: string =
  'Schedule Evaluation Meeting';
export const TAG_MAPPER_LENGTH: number = 3;
export const ZERO_MONTH_DIFFERENCE: number = 0;
